import router from '@/routers/router'

import { alerts } from '@/services/alerts';
import { load, load_close } from '@/services/load';
import { DIR, DIR_API, LOCALHOST } from '@/services/localhost';
import { cod, obj_formData, json_encode } from '@/services/useful';
import { rootAuth, rootAuth_remove, adminAuth } from '@/storages/auth';
import { SESSION_API } from '@/storages/session';


    // API
        const api = async (url, data={}, $function=null, $load=1, $errors_show=1, $timeout=0, $run_again=0, controller = new AbortController()) => {
            $load ? load($load) : ``;

            const { signal } = controller;

            const api_old = () => api(url, data, $function, $load, $errors_show, $timeout, $run_again-1, controller);
            let fechar = 1;

            // AUTH
                const header = { "Content-type": "application/json", "Accept": "application/json" };
                let token = rootAuth();
                if(token){
                    header.Authorization = `Bearer ${token}`
                }
                let token_admin = adminAuth();
                if(token_admin){
                    header.admin = token_admin;
                }
            // AUTH

            // HEADER
                // GET
                    let headers = {
                        method: "GET",
                        headers: header,
                        signal: signal
                    }
                // GET

                if(data){
                    // FORMDATA
                        if(data.FORM != null){
                            data.FORM.v = tratment_ini(data.FORM.v, url)
                            let $FormData = obj_formData(data.FORM.v);

                            // FILES
                                for(let key in data.FORM){
                                    if(key == 'FILES'){
                                        for(let key_1 in data.FORM[key]){
                                            for(let key_2 in data.FORM[key][key_1]){
                                                $FormData.append(`FILES__${key_1}[${key_2}]`, data.FORM[key][key_1][key_2]);
                                            }
                                        }
                                    }
                                    if(key == 'FILES_DELETE'){
                                        for(let key_1 in data.FORM[key]){
                                            if(data.FORM[key][key_1].length > 0){
                                                $FormData.append(`FILES_DELETE__${key_1}`, data.FORM[key][key_1]);
                                            }
                                        }
                                    }
                                }
                            // FILES

                            headers = {
                                method: 'POST',
                                body: $FormData,
                                headers: token ? { "Authorization": `Bearer ${token}` } : {},
                                signal: signal
                            }
                        }
                    // FORMDATA

                    // POST / PUT / DELETE
                        else {
                            data = tratment_ini(data, url)

                            headers = {
                                method: 'POST',
                                body: JSON.stringify(data),
                                headers: header,
                                signal: signal
                            }
                        }
                    // POST / PUT / DELETE
                }
            // HEADER

            let req__;
            let json__;
            let fetchPromise;
            let timeoutPromise;

            try {
                fetchPromise = fetch(`${DIR_API()}${url}`, headers);

                timeoutPromise = new Promise((_, reject) => {
                    if($timeout>0){
                        setTimeout(() => {
                            controller.abort();
                            reject(new Error(`Request timed out: ${url}`));
                        }, $timeout)
                    }
                });

                req__ = await Promise.race([fetchPromise, timeoutPromise]);
                json__ = await req__.json();

                load_close();
                return computed(req__, json__, api_old, url, headers, fechar, $function, $errors_show, $run_again);

            } catch(e){
                load_close();
                error_log(req__, json__, e, api_old, url, headers, fechar, $function, $errors_show);
            }
        }

        const tratment_ini = (data, url) => {
            //data.DIR = DIR__();
            data.GET = $_GET;

            data = SESSION_API(data, url);

            // ARRAY | CHECK
                for(let key in data){
                    if(Array.isArray(data[key])){
                        data[key] = data[key];
                        data[`${key}__json`] = JSON.stringify(data[key]);
                    }
                }
            // ARRAY | CHECK

            return data;
        }
    // API







    // COMMPUTED
        const computed = (req, json, api_old, url, headers, fechar, $function, $errors_show, $run_again) => {

            // EVENTS
                if(req.status != 200){
                    if($run_again>0){ setTimeout(() => { api_old(); }, .5); }
                }
            // EVENTS

            
            // 200
                if(req.status == 200){
                    treatment(req, json, api_old, url, headers, fechar, $function, $errors_show);
                    return json;
                }
            // 200

            // 400 (Bad Request)
                else if(req.status == 400){
                    alerts(0, `O servidor está com instabilidade. Tente acessar novamente em alguns segundos! Caso não consigo entre em contato como o suporte!`);
                }
            // 400 (Bad Request)

            // 401 (Unauthorized)
                else if(req.status == 401){
                    rootAuth_remove();
                    router.push('/login/');
                    return false;
                }
            // 401 (Unauthorized)

            // 403 (Forbidden)
                else if(req.status == 403){
                    rootAuth_remove();
                    router.push('/login/');
                    return false;
                }
            // 403 (Forbidden)

            // 404 (Not Found)
                else if(req.status == 404){
                    //alerts(0, `Página não encontrada!`);
                }
            // 404 (Not Found)

            // 405 (Method Not Allowed)
                else if(req.status == 405){
                    alerts(0, `Método não permitido!`);
                }
            // 405 (Method Not Allowed)

            // 422 (Unprocessable Content)
                else if(req.status == 422){
                    treatment(req, json, api_old, url, headers, fechar);
                }
            // 422 (Unprocessable Content)

            // 429 Too Many Requests
                else if(req.status == 429){
                    if($errors_show){
                        alert(`Você fez muitas requisições em um espaço muito curto de tempo! Por segurança o servidor está limitando o número de requisições. Tente acessar novamente mais tarde!`);
                    }
                }
            // 429 Too Many Requests

            // 500 (Internal Server Error)
                // else if(req.status == 500 || req.status == 502 || req.status == 503 || req.status == 504){
                //     alerts(0, `O servidor está com instabilidade. Tente acessar novamente em alguns segundos! Código: ${req.status}.`);
                // }
            // 500 (Internal Server Error)

            // ELSE
                else {
                    error_log(req, json, ``, api_old, url, headers, fechar, $function, $errors_show);
                    return false;
                }
            // ELSE
        }
    // COMMPUTED







    // TREATMENT
        const treatment = (req, json, api_old, url, headers, fechar, $function=``, $errors_show) => {
            // ERRORS
                if((json.error && json.error != null) && !(json.errors && json.errors != null)){
                    json.errors = json.error;
                }
                if((json.errors && json.errors != null) || (json.message && json.message != null)){

                    // ERRORS
                        if(Array.isArray(json.errors) ||  json.message && json.message != null){
                            if(json.errors == null){
                                json.errors = [`${json.message}`];
                            }
                            document.querySelectorAll('.__EVENTS__ .alerts').forEach(item => { item.innerHTML = '' });
                            if(json?.errors != null){
                                for(let $key in json.errors){
                                    let item = json.errors[$key];
                                    if(Array.isArray(item)){
                                        for(let $value_1 of item){
                                            alerts(0, $value_1, 1);
                                        }
                                    } else {
                                        alerts(0, item, 1);
                                    }
                                }
                            }
                        }
                    // ERRORS           

                    // ERROR_LOG
                        else {
                            error_log(req, json, json.errors, api_old, url, headers, fechar, $function, $errors_show);
                            return false;
                        }
                    // ERROR_LOG
                }
            // ERRORS

            // LOCATION
                else if(json.location != null && json.location){
                    //router.push(json.location);
                    window.location = `${DIR()}${json.location}`;
                }
            // LOCATION

            // VERIFICAR STATUS DO REQUEST
                else if(json?.status != 200){
                    alerts(0, `Ocoreu algum erro na resposta da requisição!`);
                }
            // VERIFICAR STATUS DO REQUEST

            // FUNCTION
                else if($function){
                    $function(json);
                }
            // FUNCTION

            // ALERTS
                if(json.alert != null && json.errors == null){
                    if(json.msg){
                        alerts(json.alert, json.msg, 0, json.delay);
                    } else if(json.alert){
                        alerts(1, (json.alert==1 ? '': json.alert), 0, json.delay);
                    } else {
                        alerts(0, '', 0, json.delay);
                    }
                }
            // ALERTS
        }
    // TREATMENT





    // ERROR_LOG
        const error_log = (req, json, e, api_old, url, headers, fechar, $function, $errors_show) => {
            if($errors_show){
                error_box_alert(req, json, e, api_old, url, headers, fechar, $function);
                //e ? console.log(`API =>`) : ``;
                //e ? console.log(e) : ``;
            }
        }
    // ERROR_LOG







    // ERROR_BOX_ALERT
        const error_box_alert = (req, json, e, api_old, url, headers, fechar, $function) => {

            e = cod(`asc`, e.toString());

            let txt = 'Não foi possível completar a solicitação, tente novamente mais tarde. <br>Em caso de dúvida entre em contato.';
            if(req?.status == 500 || req?.status == undefined){
                txt = 'Não foi possível completar a solicitação, verifique a sua conexão com internet. <br>Em caso de dúvida entre em contato.';
            }

            let $html = ``;
            $html += `<div> `;
                $html += fechar ? `<a class="fechar"><img src="${require('@/assets/img/svg/close.svg')}" class="h20" /></a>` : ``;
                $html += `<div> `;
                    $html += `<b>Atenção</b> `;
                    $html += `<span>${txt}</span> `;
                    $html += `<button>Tentar novamente</button> `;
                $html += `</div> `;

                $html += `<div> `;
                $html += `<div class="pb5 fwb4 flexx flex_j flex_ac"> `;
                    $html += `<div class=""> `;
                        if(LOCALHOST()){
                            $html += `<form method="POST" action="${DIR_API()}/curl_error" target="_blank" > `;
                                $html += `<input name="url" value='${DIR_API()}${url}' class="dni" /> `;
                                $html += `<input name="json" value='${json_encode(headers)}' class="dni" /> `;
                                $html += `<button class="p0 m0 bd0i back0i">Ver Erro</button> `;
                            $html += `</form> `;
                        }
                    $html += `</div> `;
                    $html += `<div class="c-p c_blue_2 link mais_detalhes">mais detalhes</div> `;
                $html += `</div> `;
                    $html += `<div class="p10 o-a mais_detalhes_box ${LOCALHOST() ? '' : 'dn'} " style="max-width: ${window.innerWidth-40}px; max-height: 500px; border: 1px solid #ccc; border-radius: 5px"> `;
                        $html += (req?.status!=null || req?.statusText!=null) ? `<div class="">${req.status} - ${req?.statusText}</div> ` : `<div class="">500 - Internal Server Error!</div> `;
                        $html += e ? `<code class="pt10">${e}</code> ` : ``;
                        $html += `<div class="pt10"> `;
                            $html += json?.file ? `<div class="">File: ${json.file}</div> ` : ``;
                            $html += json?.line ? `<div class="pt2">Line: ${json.line}</div> ` : ``;
                            $html += json?.message ? `<div class="pt2">Message: ${json.message}</div> ` : ``;
                        $html += `</div> `;
                    $html += `</div> `;
                $html += `</div> `;

            $html += `</div> `;
            document.querySelector(`.__EVENTS__ .__ERRORS__`).innerHTML = $html;

            document.querySelector(`.__EVENTS__ .__ERRORS__ button`).addEventListener('click', (e) => {
                let $e = document.querySelector(`.__EVENTS__ .__ERRORS__`);
                if($e){
                    $e.innerHTML = '';
                }
                api_old();
            })

            document.querySelector(`.__EVENTS__ .__ERRORS__ a.fechar`).addEventListener('click', (e) => {
                let $e = document.querySelector(`.__EVENTS__ .__ERRORS__`);
                if($e){
                    $e.innerHTML = '';
                }
            })

            document.querySelector(`.__EVENTS__ .__ERRORS__ .mais_detalhes`).addEventListener('click', (e) => {
                let $e = document.querySelector(`.__EVENTS__ .__ERRORS__ .mais_detalhes_box`);
                if($e.classList.contains(`dn`)){
                    $e.classList.remove('dn');
                } else {
                    $e.classList.add('dn');
                }
            })

        }
    // ERROR_BOX_ALERT

export default api;